/**
 * Converts a string to a hex colour code.
 * @param str - The string to convert to a colour
 * @description Converts a string to a hex colour code by generating a hash from the string.
 * The hash is then used to create a colour in the format #RRGGBB.
 * This ensures that the same string will always produce the same colour.
 * @returns A hex colour code in the format #RRGGBB.
 */
export function convertStringToColour(str: string): string {
  // Convert a string to a hash code
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Ensure the hash is positive
  let colour = '#';
  for (let i = 0; i < 3; i++) {
    // Extract the next byte from the hash
    const value = (hash >> (i * 8)) & 0xff;
    // Convert to a two-digit hexadecimal string
    colour += ('00' + value.toString(16)).substr(-2);
  }

  return colour;
}
